// extracted by mini-css-extract-plugin
export default {"indicator":"QDoRS","appear-from-above":"UMqwP","appearFromAbove":"UMqwP"};